"use client";

import React, { useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { cn } from "../lib/utils";
import loadable from "@loadable/component";

const ThemeSwitcher = loadable(() => import("./darkmode"), {
  ssr: false,
});

const navigation = [
  { name: "บทความ", href: "/blog" },
  { name: "เอกสาร", href: "/docs" },
  { name: "การใช้งาน", href: "/instruction" },
  { name: "ติดต่อเรา", href: "/contact" },
];

export default function Nav() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const companyName = "microplusleasing";
  const logo = (
    <StaticImage
      width={40}
      alt=""
      src="../images/icon.png"
      className="h-8 w-auto"
    />
  );
  const location = useLocation();
  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="absolute inset-x-0 top-0 z-50">
      <nav
        aria-label="Global"
        className="flex items-center justify-between p-6 lg:px-8"
      >
        <div className="flex lg:flex-1">
          <Link to="/" className={`-m-1.5 p-1.5 ${isActive("/") && "active"}`}>
            <span className="sr-only">{companyName}</span>
            {logo}
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-200"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <div className="hidden lg:flex lg:gap-x-12">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                "text-sm/6 font-semibold text-white",
                isActive(item.href) && "active"
              )}
            >
              {item.name}
            </Link>
          ))}
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <ThemeSwitcher />
        </div>
      </nav>
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-50" />
        <DialogPanel
          className={cn(
            "fixed inset-y-0 right-0 z-50 w-full",
            "overflow-y-auto bg-gray-900 p-6",
            "sm:max-w-sm sm:ring-1 sm:ring-gray-100/10"
          )}
        >
          <div className="flex items-center justify-between">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">{companyName}</span>
              {logo}
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-200"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-white/10">
              <div className="space-y-2 py-6">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={cn(
                      "-mx-3 block rounded-lg px-3 py-2",
                      "text-base/7 font-semibold text-white hover:bg-white/5",
                      isActive(item.href) && "active"
                    )}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
              <div className="py-6">
                <ThemeSwitcher />
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
